import React, {useState, useRef, useEffect} from "react";

import {
    TwitterShareButton,
    FacebookShareButton,
    EmailShareButton,
    WhatsappShareButton,
    FacebookIcon,
    TwitterIcon,
    EmailIcon,
    WhatsappIcon,
  } from "react-share";

export default function Share(props) {
  const url = props.src
  return (
    <div 
    style={{
      color: "white",
      backgroundColor: "black",
      textAlign: "left",
      overflow: "hidden",
      padding: props.isMobile? "5px 2vw 10px 10vw":"5px 25vw 10px 25vw",
    }}>
        <div>
        <FacebookShareButton
          url={url}
          quote={"A year of the Shahed"}
          >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <TwitterShareButton
          title={"A year of the Shahed"}
          via ={'Airwars'}
          url={url}
          >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <EmailShareButton
          url={url}
          subject={"A year of the Shahed"}
          >
          <EmailIcon size={32} round />
        </EmailShareButton>
        <WhatsappShareButton
          title={"A year of the Shahed"}
          url={url}
          >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        </div>
  </div>

)}